module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_bd_01.0b2e85d4.jpg";